"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeparturePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@lt/components/components/DurationTrip/styles");

var _utils = require("../../../../utils");

var _utils2 = require("../../utils");

var _usehooksTs = require("usehooks-ts");

var _styles2 = require("../../styles");

var _Option = _interopRequireDefault(require("./components/Option"));

var _DropdownIndicator = _interopRequireDefault(require("./components/DropdownIndicator"));

var _NoOptionsMessage = _interopRequireDefault(require("./components/NoOptionsMessage"));

var _LoadingMessage = _interopRequireDefault(require("./components/LoadingMessage"));

var _Control = _interopRequireDefault(require("./components/Control"));

var _Input = _interopRequireDefault(require("./components/Input"));

var _SingleValue = _interopRequireDefault(require("./components/SingleValue"));

var _ValueContainer = _interopRequireDefault(require("./components/ValueContainer"));

var _constants = require("./constants");

var _CloseButton = _interopRequireDefault(require("../CloseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DeparturePicker = function DeparturePicker(_ref) {
  var options = _ref.options,
      isMobile = _ref.isMobile,
      onChange = _ref.onChange,
      menuIsOpen = _ref.menuIsOpen,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isWizard = _ref.isWizard,
      value = _ref.value,
      onMenuOpen = _ref.onMenuOpen,
      onMenuClose = _ref.onMenuClose,
      inputValue = _ref.inputValue,
      onInputChange = _ref.onInputChange,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$isWidget = _ref.isWidget,
      isWidget = _ref$isWidget === void 0 ? false : _ref$isWidget,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel;
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      inputValueChanged = _useState2[0],
      setInputValueChanged = _useState2[1];

  var filterOptions = function filterOptions(_ref2, currentValue) {
    var optionValue = _ref2.value,
        label = _ref2.label,
        selectedLabel = _ref2.data.selectedLabel;
    if (!inputValueChanged) return true;
    var lowerInputValue = currentValue.toLowerCase();
    var lowerValue = optionValue.toLowerCase();
    var lowerLabel = label.toLowerCase();
    var lowerSelectedLabel = selectedLabel.toLowerCase();
    var wrongKeyboardWord = (0, _utils2.convertLatinToRus)(currentValue);

    if (currentValue) {
      return lowerValue.includes(lowerInputValue) || lowerLabel.includes(lowerInputValue) || lowerLabel.includes(wrongKeyboardWord) || lowerSelectedLabel.includes(lowerInputValue) || lowerSelectedLabel.includes(wrongKeyboardWord);
    }

    return true;
  };

  (0, _react.useEffect)(function () {
    if (menuIsOpen && ref.current) {
      ref.current.focus();

      if (_utils.isIOS && !isWidget) {
        setTimeout(function () {
          // Хак из-за того, что из-за клавиатуры инпут на айфоне улетает вверх
          // TODO: Убрать это и сделать нормально
          window.scrollTo(0, 0);
        }, 500);
      }
    }
  }, [isWidget, menuIsOpen]); // Если тыкаем где-то за пределами инпута, то скрываем клавиатуру на мобильном устройстве

  (0, _usehooksTs.useEventListener)('touchstart', function (event) {
    var _ref$current;

    var el = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.controlRef;

    if (!el || el.contains(event.target)) {
      return;
    }

    setTimeout(function () {
      var _ref$current2, _ref$current2$inputRe;

      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$inputRe = _ref$current2.inputRef) === null || _ref$current2$inputRe === void 0 ? void 0 : _ref$current2$inputRe.blur();
    }, 200);
  });

  var handleInputChange = function handleInputChange(newValue, actionMeta) {
    onInputChange && onInputChange(newValue, actionMeta);
    var action = actionMeta.action;

    if (action === 'set-value') {
      setInputValueChanged(false);
    }

    if (action === 'input-change') {
      setInputValueChanged(true);
    }
  }; // По клику в инпут сдвигаем мигающий курсор в конец строки,
  // если пользователь не менял содержимое инпута


  var onFocus = function onFocus() {
    var _ref$current3;

    var inputRef = (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.inputRef;
    if (!inputRef) return;
    value && inputRef.select();
    if (inputValueChanged) return;
    setTimeout(function () {
      inputRef.setSelectionRange(inputRef.value.length, inputRef.value.length);
    }, 0);
  }; // Запрещаем выделять текст в инпуте по клику, если пользователь
  // не менял содержимое инпута


  var selectStyles = {
    input: function input(styles) {
      return _objectSpread(_objectSpread({}, styles), !inputValueChanged && {
        userSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none'
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(StyledMobileLabel, {
    $isWhiteLabel: isWhiteLabel,
    $variant: variant
  }, _constants.departurePlaceholder), /*#__PURE__*/_react["default"].createElement(SelectContainer, {
    $isMobile: !!isMobile,
    $isWizard: !!isWizard,
    className: className,
    $withCloseButton: menuIsOpen && isMobile && !isWizard,
    $variant: variant,
    $isWidget: isWidget
  }, isMobile && !isWizard && menuIsOpen && /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    onClick: onMenuClose
  }), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    ref: ref,
    options: options,
    defaultValue: !isWizard ? value : undefined,
    inputValue: !_utils.isTouchScreen || _utils.isTouchScreen && menuIsOpen ? inputValue : undefined
    /**
     * Нужно, чтобы при очищении поля в нём не оставалось
     * ранее выбранное значение
     */
    ,
    value: inputValue ? value : null,
    className: _constants.departurePickerName,
    classNamePrefix: _constants.departurePickerName,
    placeholder: _constants.departurePlaceholder,
    isMulti: false,
    isClearable: true,
    backspaceRemovesValue: true,
    escapeClearsValue: false,
    components: _objectSpread(_objectSpread({
      Option: _Option["default"],
      Control: _Control["default"],
      NoOptionsMessage: _NoOptionsMessage["default"],
      LoadingMessage: _LoadingMessage["default"],
      Input: _Input["default"],
      DropdownIndicator: _utils.isTouchScreen ? null : _DropdownIndicator["default"],
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      ClearIndicator: function ClearIndicator() {
        return null;
      }
    }, !_utils.isTouchScreen ? {
      SingleValue: function SingleValue() {
        return null;
      }
    } : {
      SingleValue: _SingleValue["default"]
    }), {}, {
      ValueContainer: _ValueContainer["default"]
    }),
    isLoading: isLoading,
    onChange: onChange,
    onFocus: onFocus,
    onInputChange: handleInputChange,
    onMenuOpen: onMenuOpen,
    onMenuClose: _utils.isTouchScreen && !isWizard ? undefined : onMenuClose,
    menuIsOpen: menuIsOpen,
    menuShouldScrollIntoView: false,
    isDisabled: isDisabled,
    isSearchable: !_utils.isTouchScreen || menuIsOpen,
    filterOption: filterOptions,
    "aria-label": _constants.departurePlaceholder,
    styles: selectStyles
  })));
};

exports.DeparturePicker = DeparturePicker;

var SelectContainer = _styledComponents["default"].div.withConfig({
  displayName: "DeparturePicker__SelectContainer",
  componentId: "sc-hyz9n3-0"
})(["position:relative;.", "{font-size:14px;line-height:16px;color:#17181a;&__control{min-width:150px;padding:8px;border:0;box-shadow:none;height:56px;caret-color:#007aff;border-radius:unset;font-weight:500;color:inherit;", " &:hover{border-color:var(--orange);}", " &--menu-is-open{font-weight:normal;& .", "__indicator{transform:rotate(180deg);}}}&__input-container:not([data-value='']){padding:", ";&::before{content:'\u0438\u0437';position:absolute;}}", " &__menu{min-width:245px;margin:0;padding-top:8px;box-shadow:0 2px 4px rgb(210 208 197 / 80%);border-radius:var(--border-radius);@media (min-width:1200px){width:320px;}&:after{content:'';height:30px;position:absolute;left:0;bottom:0;right:0;background:linear-gradient(180deg,rgba(255,255,255,0) 0%,#ffffff 100%);border-radius:var(--border-radius);}&-list{padding:0;}}&__option{padding:4px 8px 8px;cursor:pointer;&:last-of-type{padding-bottom:24px;}&--is-focused{background-color:var(--background);}&--is-selected{background-color:var(--background);}&:active{background-color:var(--grey3);}}&__single-value{display:flex;align-items:center;color:inherit;}&__value-container{padding:0;&:after{content:'';width:24px;position:absolute;top:0;bottom:0;right:0;}}&__placeholder{color:#919499;font-weight:normal;}&__indicator{padding:0;}&__icon-search{display:none;}", ";}", ";", ";", ";", ""], _constants.departurePickerName, function (_ref3) {
  var $variant = _ref3.$variant;
  return $variant === 'hotel' && (0, _styledComponents.css)(["background-color:var(--background);"]);
}, function (_ref4) {
  var $isMobile = _ref4.$isMobile,
      $isWizard = _ref4.$isWizard;
  return $isMobile && !$isWizard && "&:hover {\n        border: none;\n      }";
}, _constants.departurePickerName, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile ? '0 0 0 24px' : '0 0 0 18px';
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return !$isMobile && "\n       /* fix small input touch bug */\n       &__input-container {\n         display: block;\n\n         & > input {\n           display: inline-block;\n         }\n\n         &::after {\n           content: none;\n         }\n\n         &::before {\n          left: 0;\n         }\n       }\n     ";
}, function (_ref7) {
  var $isWizard = _ref7.$isWizard;
  return $isWizard && (0, _styledComponents.css)(["&__control{margin-top:0;}"]);
}, function (_ref8) {
  var $isMobile = _ref8.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["width:100%;.", "{&__control{", "}&__indicator{display:none;}&__menu{height:100vh;max-width:100%;left:0;border-radius:0;&-list{padding-bottom:60px;}}&__placeholder{color:#c2c5cc;font-weight:normal;}}"], _constants.departurePickerName, _styles2.mobileDefaultControlStyles);
}, function (_ref9) {
  var $isWizard = _ref9.$isWizard;
  return $isWizard && (0, _styledComponents.css)(["flex-grow:0;.", "{&__indicator{display:none;}&__control{max-width:100%;background-color:transparent;padding:0;min-height:initial;height:initial;border:none;font-weight:normal;&--menu-is-open{border:1px solid var(--grey2);border-radius:var(--border-radius);background-color:#fff;margin:8px;padding:14px 8px;.", "__value-container{justify-content:start;}.", "__icon-search{display:block;}}}&__menu-list{height:calc(100vh - 144px);max-height:initial;}&__value-container{justify-content:center;}&__input-container{padding:0;margin:0;}&__single-value--is-disabled{color:inherit;}}"], _constants.departurePickerName, _constants.departurePickerName, _constants.departurePickerName);
}, function (_ref10) {
  var $withCloseButton = _ref10.$withCloseButton,
      $variant = _ref10.$variant;
  return $withCloseButton && (0, _styledComponents.css)(["position:fixed;transform:translate3d(0,0,0);top:0;left:0;right:0;z-index:", ";background-color:#f5f4f2;.", "{padding:8px 40px 8px 8px;&__control{border:none;}&__menu{width:100%;right:0;left:0;background-color:#f5f4f2;position:absolute;z-index:1;padding-top:0px;&-list{height:calc(100vh - ", ");max-height:none;background-color:#fff;padding-top:8px;border-radius:8px 8px 0 0;overflow:scroll;}}&__icon-search{display:inline;}}"], $variant === 'hotel' ? '10001' : '1', _constants.departurePickerName, _utils.isIOS ? '150px' : '64px');
}, function (_ref11) {
  var $isMobile = _ref11.$isMobile,
      $isWidget = _ref11.$isWidget,
      $isWizard = _ref11.$isWizard;
  return $isWidget && $isMobile && !$isWizard && _styles2.mobileWidgetInputStyles;
}); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore


var StyledCloseButton = (0, _styledComponents["default"])(_CloseButton["default"]).attrs({
  $inMobileInput: true
}).withConfig({
  displayName: "DeparturePicker__StyledCloseButton",
  componentId: "sc-hyz9n3-1"
})(["margin-top:24px;margin-right:12px;"]);
var StyledMobileLabel = (0, _styledComponents["default"])(_styles.MobileLabel).withConfig({
  displayName: "DeparturePicker__StyledMobileLabel",
  componentId: "sc-hyz9n3-2"
})(["margin-bottom:4px;"]);